export default __webpack_public_path__ + "static/media/kohlendioxid.0171923e.png";